import { buildStaffMenu } from "./staffMenu"
// Also available for Teacher Training-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Teacher Training role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add Teacher Training-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildTeacherTrainingMenu = () => buildStaffMenu()
